import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { Editor, Events, stateMap, mouseType,
// judgeState
 } from './config/editor';
import { transformVertex } from '@blade/common/utils/rzcanvas/util';
import ImageToolTip from './image-tooltip.vue';
let ImageEditor = class ImageEditor extends Vue {
    drawState;
    showDrawer;
    imageSrc;
    options;
    config;
    allowDraw;
    outerCircles;
    editorMode;
    currVal;
    containerStyle = {};
    Editor; // it will not be observe
    mouseState = '';
    scale = 1;
    // 缩放配置
    maxScale = 5;
    minScale = 1;
    canvasPosition = {
        x: 0,
        y: 0,
    };
    canvasStyle = {};
    currentPosition = {
        clientX: 0,
        clientY: 0,
    };
    /* 记录之前位置 ,以避免画标注时,移动画布还画标注 */
    prevPosition = {
        clientX: 0,
        clientY: 0,
    };
    hoverIndex = -1;
    mouseHoverVertex = { x: 0, y: 0 };
    divStyle = {};
    imageOriginSize = { width: 0, height: 0 };
    isRightClicking = false;
    showEdit = false;
    editStyle = {};
    showAdd = false;
    addStyle = {};
    currCircleIndex = -1;
    imageLoading = false;
    imageTooltipLoading = false;
    cancelToken;
    currQueueing = {};
    prevScale = 0;
    get showCanvas() {
        return this.showDrawer || this.drawState;
    }
    handleImageChange() {
        this.destroyEditor();
        this.init();
    }
    onShowEditChange(newVal) {
        this.hoverIndex = -1;
    }
    onCirclesChange(newVal) {
        console.log('new val:', newVal);
        if (this.Editor) {
            // this.Editor.circles = newVal;
            this.Editor.addCircles(newVal);
            this.Editor.drawCircles();
        }
        if (this.hoverIndex >= 0) {
            this.getDeviceInfo(this.hoverIndex);
        }
    }
    onCurrValChange(newVal) {
        this.handleResize();
    }
    handleDrawCircles(circles) {
        return circles;
    }
    handleDrawCircleDone(circles) {
        console.log('circles');
        return circles;
    }
    handleChangeState(state) {
        return state;
    }
    // handleResize(){
    //   this.init();
    // }
    handleDelete(e) {
        console.log('delete');
        const currCircle = this.Editor.circles[this.currCircleIndex];
        this.$emit('on-delete', currCircle);
    }
    handleEdit() {
        const currCircle = this.Editor.circles[this.currCircleIndex];
        this.$emit('on-edit', currCircle);
    }
    handleCreate() {
        this.$emit('on-create');
    }
    resetStyle() {
        this.canvasPosition = { x: 0, y: 0 };
        this.currentPosition = { clientX: 0, clientY: 0 };
        this.scale = 1;
        this.canvasStyle = this.getCanvasStyle();
    }
    mounted() {
        this.init();
        this.addDocumentListen();
    }
    beforeDestroy() {
        const parentRef = this.$refs.parent;
        if (!parentRef) {
            return;
        }
        parentRef.removeEventListener('mouseup', this.handleMouseUp);
        parentRef.removeEventListener('contextmenu', this.handleMouseUp);
        this.destroyEditor();
    }
    addDocumentListen() {
        const parentRef = this.$refs.parent;
        console.log('parentRef:', parentRef);
        if (!parentRef) {
            return;
        }
        parentRef.removeEventListener('mouseup', this.handleMouseUp);
        parentRef.addEventListener('mouseup', this.handleMouseUp);
        parentRef.addEventListener('contextmenu', this.handleClick);
    }
    handleClick(event) {
        event.preventDefault();
    }
    handleMouseMove(event) {
        if (this.Editor) {
            // console.log("view point:", window.innerHeight)
            const currPosition = {
                clientX: event.clientX,
                clientY: event.clientY,
            };
            const vertex = transformVertex(event, this.scale);
            const isExsit = this.Editor ? this.Editor.isCircleExist(vertex) : -1;
            this.hoverIndex = !this.showEdit ? isExsit : -1;
            if (isExsit >= 0 && !this.showEdit) {
                this.mouseHoverVertex = this.Editor.circles[isExsit].vertex;
                this.divStyle = this.getDivStyle(300, 155, 300, currPosition.clientY);
            }
        }
    }
    getImageDom() {
        if (!this.imageSrc) {
            throw new Error('the imageSrc must exist and be unique ');
        }
        const image = new Image();
        return new Promise((resolve, reject) => {
            image.src = this.imageSrc;
            image.onload = event => {
                const target = event.target;
                this.imageOriginSize = {
                    width: target?.width || 0,
                    height: target?.height || 0,
                };
                const { naturalWidth: width, naturalHeight: height } = target;
                const containerStyle = this.$el.getBoundingClientRect();
                this.containerStyle = containerStyle;
                console.log('container style:', this.containerStyle);
                resolve({
                    containerStyle: containerStyle,
                    imageSize: { width, height },
                    image: event.target,
                });
            };
        });
    }
    // async getComputedStyle(): Promise<any> {
    //   return new Promise((resolve, reject) => {
    //     this.getImageDom().then(({ containerStyle, imageSize, image }) => {
    //       this.containerStyle = containerStyle;
    //       if (!this.containerStyle.height) {
    //         throw new Error('[Razor Error] the container height is unset');
    //       }
    //       resolve({ containerStyle: this.containerStyle, image, imageSize });
    //     });
    //   });
    // }
    async init() {
        this.imageLoading = true;
        const { containerStyle, imageSize, image } = await this.getImageDom();
        this.imageLoading = false;
        const { circleLength } = this.config;
        const config = { containerStyle, imageSize, circleLength };
        const canvasElem = this.$refs.canvas;
        const options = this.options;
        if (image && containerStyle) {
            this.Editor = new Editor(canvasElem, config, options, image);
            // this.Editor.circles = this.outerCircles;
            this.Editor.addCircles(this.outerCircles);
            this.Editor.drawCircles();
            this.Editor.on(Events.drawCircles, this.handleDrawCircles);
            this.Editor.on(Events.drawCircleDone, this.handleDrawCircleDone);
            this.getCanvasStyle();
        }
    }
    handleMouseDown(event) {
        this.mouseState = mouseType.down;
        this.currentPosition = {
            clientX: event.clientX,
            clientY: event.clientY,
        };
        this.prevPosition = {
            clientX: event.clientX,
            clientY: event.clientY,
        };
        const vertex = transformVertex(event, this.scale);
    }
    handleCanvasMouseMove(event) {
        if (this.mouseState === mouseType.down) {
            this.mouseState = mouseType.move;
        }
        // 不是画矩形的状态 关闭
        if (this.mouseState !== mouseType.move) {
            this.handleMouseMove(event);
        }
        else {
            this.moveCanvas(event);
        }
        //   if (this.drawState === stateMap.screenShot) {
        //     const vertex = transformVertex(event, this.scale);
        //     this.Editor.drawScreenshot(vertex);
        //   } else {
        //   }
    }
    rightClick(event) {
        let isRightMB;
        const e = event || window.event;
        if ('which' in e) {
            // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
            isRightMB = Number(e.which) === 3;
        }
        else if ('button' in e) {
            // IE, Opera
            isRightMB = Number(e.button) === 2;
        }
        console.log('right click:', isRightMB);
        return isRightMB;
    }
    closePopover() {
        if (this.showEdit) {
            this.showEdit = false;
        }
        if (this.showAdd) {
            this.showAdd = false;
        }
    }
    showEditPopover(circleIndex, event) {
        this.showEdit = true;
        const currPositionY = event.clientY;
        this.currCircleIndex = circleIndex;
        this.mouseHoverVertex = this.Editor ? this.Editor.circles[circleIndex].vertex : { x: 0, y: 0 };
        this.editStyle =
            this.editorMode === 'VIEW' ? this.getDivStyle(213, 90, 213, currPositionY) : this.getDivStyle(213, 45, 213, currPositionY);
    }
    showAddPopover(event) {
        console.log(event);
        const currPositionY = event.clientY;
        this.mouseHoverVertex = { x: event.offsetX / this.scale, y: event.offsetY / this.scale };
        this.showAdd = true;
        this.addStyle = this.getDivStyle(213, 45, 213, currPositionY);
    }
    handleMouseUp(event) {
        this.hoverIndex = -1;
        this.mouseState = mouseType.up;
        const vertex = transformVertex(event, this.scale);
        // console.log("vertext:", vertex)
        let circleIndex = -1;
        circleIndex = this.Editor ? this.Editor.isCircleExist(vertex) : -1;
        const isRightClick = this.rightClick(event);
        if (isRightClick) {
            this.closePopover();
            if (this.Editor.circles.length > 0 && circleIndex >= 0) {
                this.showEditPopover(circleIndex, event);
            }
            else {
                this.showAddPopover(event);
            }
            return;
        }
        if (this.showEdit) {
            this.showEdit = false;
            return;
        }
        if (this.showAdd) {
            this.showAdd = false;
            return;
        }
        if (!event || !this.$el.contains(event.target)) {
            // //   // 鼠標移出容器的兼容
            // //   if (this.drawState === stateMap.screenShot) {
            // //     screenShot = this.Editor.getScreeShot();
            // //     if (!screenShot) {
            // //       return;
            // //     }
            // //     this.handleScreenShotDone(screenShot);
            // //   }
            this.currentPosition = null;
            return;
        }
        const isExist = this.Editor ? this.Editor.isCircleExist(vertex) : -1;
        console.log('circle:', isExist >= 0);
        if (isExist >= 0 && this.editorMode === 'VIEW') {
            this.$emit('open-dialog', this.Editor.circles[isExist]);
            return;
        }
        switch (this.drawState) {
            case stateMap.circle:
                if (
                // 鼠标移动了则不画标注
                this.prevPosition.clientX !== this.currentPosition?.clientX ||
                    this.prevPosition.clientY !== this.currentPosition?.clientY) {
                    break;
                }
                if (this.Editor.circles.length && circleIndex >= 0) {
                    // this.Editor.removeCircle(circleIndex);
                    return;
                }
                else {
                    if (this.editorMode === 'EDIT') {
                        this.Editor.addCircle(vertex);
                    }
                }
                break;
            case stateMap.screenShot:
                // screenShot = this.Editor.getScreeShot();
                // if (!screenShot) {
                //   break;
                // }
                // this.handleScreenShotDone(screenShot);
                break;
            case stateMap.drawRects:
                // this.selectRect(vertex);
                break;
            default:
                break;
        }
        this.currentPosition = null;
    }
    handleWheel(event, scaleStep = 0.1) {
        // this.swallowEvent(event);
        // const maxScale = this.Editor && this.Editor.rect.scale ? this.Editor.rect.scale : 1;
        const canvasElem = this.$refs.canvas;
        // 当前位置
        const boundingRect = canvasElem.getBoundingClientRect();
        // if (boundingRect.width >= this.imageOriginSize.width && event.deltaY < 0) {
        // return;
        // }
        const scaleFlag = event.deltaY < 0;
        let newScale = this.scale + scaleStep * (scaleFlag ? 1 : -1);
        if (newScale > this.maxScale) {
            newScale = this.maxScale;
        }
        else if (newScale < this.minScale) {
            newScale = this.minScale;
        }
        const x = event.clientX - boundingRect.left;
        const y = event.clientY - boundingRect.top;
        const changeRate = newScale / this.scale;
        this.scale = newScale;
        if (newScale === this.minScale) {
            this.canvasPosition = {
                x: 0,
                y: 0,
            };
        }
        else {
            // 换算后新的位置
            this.canvasPosition = {
                x: this.canvasPosition.x - (changeRate - 1) * x,
                y: this.canvasPosition.y - (changeRate - 1) * y,
            };
        }
        this.canvasStyle = this.getCanvasStyle();
        this.Editor.zoom(this.scale);
    }
    handleResize() {
        const val = Number(this.currVal);
        const maxScale = this.Editor && this.Editor.rect.scale ? this.Editor.rect.scale : 1;
        const canvasElem = this.$refs.canvas;
        const boundingRect = canvasElem.getBoundingClientRect();
        const newScale = 1 + Number(((maxScale - 1) * (val / 100)).toFixed(2));
        const posDir = this.prevScale < val ? 1 : -1;
        // this.scale = newScale;
        const x = canvasElem.width / 2;
        const y = canvasElem.height / 2;
        console.log('canvas elem:', canvasElem);
        const changeRate = newScale / this.scale;
        this.scale = newScale;
        // if (newScale === this.minScale) {
        //   this.canvasPosition = {
        //     x: 0,
        //     y: 0,
        //   };
        // } else {
        // 换算后新的位置
        this.canvasPosition = {
            x: this.canvasPosition.x - (changeRate - 1) * x,
            y: this.canvasPosition.y - (changeRate - 1) * y,
        };
        this.calibrateCanvas(canvasElem);
        // }
        // this.canvasStyle = this.getCanvasStyle();
        // this.Editor.zoom(this.scale);
        this.prevScale = val;
    }
    calibrateCanvas(canvasElem) {
        const divRect = this.$refs.parent;
        const divBoundingRect = divRect.getBoundingClientRect();
        if (this.canvasPosition.x > 0) {
            this.canvasPosition.x = 0;
        }
        if (this.canvasPosition.y > 0) {
            this.canvasPosition.y = 0;
        }
        if (this.canvasPosition.x + divBoundingRect.width * this.scale < divBoundingRect.width) {
            const diffRight = divBoundingRect.width - divBoundingRect.width * this.scale - this.canvasPosition.x;
            this.canvasPosition.x = this.canvasPosition.x + diffRight;
        }
        if (this.canvasPosition.y + divBoundingRect.height * this.scale < divBoundingRect.height) {
            const diffHeight = divBoundingRect.height - divBoundingRect.height * this.scale - this.canvasPosition.y;
            this.canvasPosition.y = this.canvasPosition.y + diffHeight;
        }
        this.canvasStyle = this.getCanvasStyle();
        this.Editor.zoom(this.scale);
    }
    moveCanvas(event) {
        this.swallowEvent(event);
        this.mouseState = mouseType.move;
        const { clientX, clientY } = event;
        const movementX = this.currentPosition ? clientX - this.currentPosition.clientX : clientX - 0;
        const movementY = this.currentPosition ? clientY - this.currentPosition?.clientY : clientY - 0;
        /* 距离太小不做操作 */
        if ((movementX > 0 && movementX < 5) ||
            (movementY > 0 && movementY < 5) ||
            (movementX < 0 && movementX > -5) ||
            (movementY < 0 && movementY > -5)) {
            return;
        }
        this.hoverIndex = -1;
        this.checkMove(movementX, movementY, this.currentPosition?.clientX || 0, this.currentPosition?.clientY || 0, event);
        // this.canvasPosition.x += movementX;
        // this.canvasPosition.y += movementY;
        // this.canvasStyle = this.getCanvasStyle();
        // this.currentPosition = { clientX, clientY };
    }
    checkMove(movementX, movementY, preX, preY, event) {
        const canvasEle = this.$refs.canvas;
        const boundingRect = canvasEle.getBoundingClientRect();
        const containerEle = this.$refs.parent;
        const divRect = containerEle.getBoundingClientRect();
        let clientCurrX = preX;
        let clientCurrY = preY;
        if (movementY < 0 && movementY + boundingRect.bottom >= divRect.bottom) {
            this.canvasPosition.y += movementY;
            clientCurrY = event.clientY;
        }
        if (movementY > 0 && boundingRect.top + movementY <= divRect.top) {
            this.canvasPosition.y += movementY;
            clientCurrY = event.clientY;
        }
        if (movementX < 0 && movementX + boundingRect.right >= divRect.right) {
            this.canvasPosition.x += movementX;
            clientCurrX = event.clientX;
        }
        if (movementX > 0 && boundingRect.left + movementX <= divRect.left) {
            this.canvasPosition.x += movementX;
            clientCurrX = event.clientX;
        }
        this.canvasStyle = this.getCanvasStyle();
        this.currentPosition = { clientX: clientCurrX, clientY: clientCurrY };
    }
    getDivStyle(boxW, boxH, boxOffsetL, viewPointHeight) {
        const vertex = this.mouseHoverVertex;
        const parentStartVertex = this.$el.getBoundingClientRect();
        const canvasStartVertext = this.$refs.canvas;
        const toPositionPopover = { x: 0, y: 0 };
        const boxWidth = boxW;
        const boxHeight = boxH;
        const boxOffsetLeft = -boxOffsetL;
        const boxOffsetTop = 10;
        const leftBound = boxWidth * this.scale;
        const upperBound = boxHeight * this.scale;
        const leftSpace = vertex.x + canvasStartVertext.offsetLeft;
        const bottomSpace = parentStartVertex.bottom - vertex.y - canvasStartVertext.offsetTop - 40 - parentStartVertex.top;
        // Left top of the box starts at the center of the point
        toPositionPopover.x = vertex.x * this.scale + canvasStartVertext.offsetLeft;
        toPositionPopover.y = vertex.y * this.scale + canvasStartVertext.offsetTop;
        // Adjust offsets of the box for aethetic purpose
        toPositionPopover.x = toPositionPopover.x + boxOffsetLeft;
        toPositionPopover.y = toPositionPopover.y + boxOffsetTop;
        const viewPointVertical = window.innerHeight - viewPointHeight;
        if (bottomSpace < boxHeight || viewPointVertical < boxHeight) {
            toPositionPopover.y = toPositionPopover.y - boxHeight - 20;
        }
        if (leftSpace < boxWidth) {
            toPositionPopover.x = toPositionPopover.x - boxOffsetLeft + 20;
        }
        const style = {
            position: 'absolute',
            background: 'rgba(0,0,0,0.7)',
            width: `${boxW}px`,
            height: `${boxH}px`,
            top: `${toPositionPopover.y}px`,
            left: `${toPositionPopover.x}px`,
            'border-radius': '5px',
        };
        return style;
    }
    // 设置canvas的位置
    getCanvasStyle() {
        const { width, height } = this.containerStyle;
        return {
            width: `${width * this.scale}px`,
            height: `${height * this.scale}px`,
            top: `${this.canvasPosition.y}px`,
            left: `${this.canvasPosition.x}px`,
            'border-radius': '5px',
        };
    }
    swallowEvent(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    // drawRects() {
    //   const rects = this.rects.map(rect => {
    //     const vertexes = rect.vertexes.map(vertex =>
    //       this.Editor.shrinkVertex(vertex)
    //     );
    //     return { ...rect, vertexes };
    //   });
    //   if (rects.length) this.Editor.drawRects(rects);
    // }
    // getScreeShot() {
    //   this.Editor.getScreeShot();
    // }
    // selectRect(vertex) {
    //   if (!this.rects || !this.rects.length) {
    //     console.warn("[Razor Warning] no rects exist");
    //     return;
    //   }
    //   let targetIndex = -1;
    //   targetIndex = this.Editor.selectRect(vertex);
    //   let i = this.rects.length;
    //   let isRectSelected = true; // 多选模式下使用 , 是选中还是反选
    //   if (targetIndex < 0) {
    //     return;
    //   }
    //   while (i--) {
    //     if (this.mode === "radio") {
    //       // 单选
    //       if (i === targetIndex) {
    //         this.rects[i].options.dashed = false; // 命中
    //       } else {
    //         this.rects[i].options.dashed = true;
    //       }
    //     } else {
    //       // 多选
    //       if (i === targetIndex) {
    //         this.rects[i].options.dashed = !this.rects[i].options.dashed; // 命中
    //         isRectSelected = !this.rects[i].options.dashed;
    //       }
    //     }
    //   }
    //   this.drawRects();
    //   const { vertexes, options } = this.Editor.rects[targetIndex];
    //   let _vertexes = vertexes.map(vertex => {
    //     return this.Editor.transformVertex(vertex);
    //   });
    //   const start = _vertexes[0];
    //   const end = _vertexes[1];
    //   // 防止坐标起点跟右下角反了
    //   if (start.x >= end.x) {
    //     _vertexes = [end, start];
    //   }
    //   if (this.mode === "radio") {
    //     // 单选
    //     this.selectedRects = [_vertexes];
    //   } else {
    //     // 多选
    //     this.selectedRects = this.getSelectedRects(
    //       this.selectedRects,
    //       _vertexes,
    //       isRectSelected
    //     );
    //   }
    //   this.handleSelectRect(
    //     { vertexes: _vertexes, options },
    //     targetIndex,
    //     this.selectedRects
    //   );
    // }
    // getSelectedRects(selectedRects, _vertexes, isRectSelected) {
    //   let _selectedRects = [...selectedRects];
    //   if (isRectSelected) {
    //     // 避免有已选的坐标重复的情况
    //     const isExist = _selectedRects.findIndex(rect => {
    //       return (
    //         rect[0].x === _vertexes[0].x &&
    //         rect[0].y === _vertexes[0].y &&
    //         rect[1].x === _vertexes[1].x &&
    //         rect[1].y === _vertexes[1].y
    //       );
    //     });
    //     if (isExist > -1) {
    //       return _selectedRects;
    //     }
    //     _selectedRects.push(_vertexes);
    //   } else {
    //     _selectedRects = selectedRects.filter(rect => {
    //       return (
    //         rect[0].x !== _vertexes[0].x &&
    //         rect[0].y !== _vertexes[0].y &&
    //         rect[1].x !== _vertexes[1].x &&
    //         rect[1].y !== _vertexes[1].y
    //       );
    //     });
    //   }
    //   return _selectedRects;
    // }
    destroyEditor() {
        this.Editor && this.Editor.dispose();
        this.Editor = null;
    }
    handleZoom(scaleFlag) {
        const rect = this.$refs.canvas.getBoundingClientRect();
        if (rect.width >= this.imageOriginSize.width) {
            return;
        }
        const event = {
            clientX: (rect.left + rect.right) / 2,
            clientY: (rect.top + rect.bottom) / 2,
            deltaY: 1,
            stopPropagation() { },
            preventDefault() { },
        };
        if (scaleFlag) {
            event.deltaY = -1;
        }
        else {
            event.deltaY = 1;
        }
        const scaleStep = 0.3;
        this.handleWheel(event, scaleStep);
    }
    onHoverIndexChange(newVal, oldVal) {
        this.cancelToken && this.cancelToken.cancel();
        if (newVal >= 0 && this.editorMode === 'VIEW') {
            this.getDeviceInfo(newVal);
        }
        else {
        }
    }
    async getDeviceInfo(id) {
        console.log('id:', id);
        this.currQueueing = { name: this.Editor.circles[id].meta.taskName, ...this.Editor.circles[id].meta.taskDetail };
    }
};
__decorate([
    Prop({ type: Number, default: 0, required: true })
], ImageEditor.prototype, "drawState", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ImageEditor.prototype, "showDrawer", void 0);
__decorate([
    Prop({ type: String, default: '', required: true })
], ImageEditor.prototype, "imageSrc", void 0);
__decorate([
    Prop({
        type: Object,
        default() {
            return {};
        },
    })
], ImageEditor.prototype, "options", void 0);
__decorate([
    Prop({
        type: Object,
        default() {
            return {};
        },
    })
], ImageEditor.prototype, "config", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ImageEditor.prototype, "allowDraw", void 0);
__decorate([
    Prop({ type: Array, default: false })
], ImageEditor.prototype, "outerCircles", void 0);
__decorate([
    Prop({ type: String, default: 'VIEW' })
], ImageEditor.prototype, "editorMode", void 0);
__decorate([
    Prop({ type: String, default: '0' })
], ImageEditor.prototype, "currVal", void 0);
__decorate([
    Watch('imageSrc')
], ImageEditor.prototype, "handleImageChange", null);
__decorate([
    Watch('showEdit')
], ImageEditor.prototype, "onShowEditChange", null);
__decorate([
    Watch('outerCircles', { immediate: true, deep: true })
], ImageEditor.prototype, "onCirclesChange", null);
__decorate([
    Watch('currVal')
], ImageEditor.prototype, "onCurrValChange", null);
__decorate([
    Emit('draw-circles')
], ImageEditor.prototype, "handleDrawCircles", null);
__decorate([
    Emit('draw-circle-done')
], ImageEditor.prototype, "handleDrawCircleDone", null);
__decorate([
    Emit('change-state')
], ImageEditor.prototype, "handleChangeState", null);
__decorate([
    Watch('hoverIndex', { immediate: true })
], ImageEditor.prototype, "onHoverIndexChange", null);
ImageEditor = __decorate([
    Component({
        name: 'ImageEditor',
        components: { 'image-tooltip': ImageToolTip },
        i18n: {
            messages: {
                'en-us': {
                    editTask: 'edit Task',
                    delete: 'delete',
                    createTask: '+ create Task',
                },
                zh: {
                    editTask: '编辑任务',
                    delete: '删除',
                    createTask: '+ 新建任务',
                },
            },
        },
    })
], ImageEditor);
export default ImageEditor;
